import React from 'react';
import ReactDOM from 'react-dom';
import buildInitialState from '@/widget/services/buildInitialState';
import ru from '@/widget/services/locales/ru.json';
import en from '@/widget/services/locales/en.json';
import actionCable from 'actioncable';
import ChatWidget from '@/widget/ui/components';
import ChatWidgetProps from '@/widget/widgetPropsInterface';
import cyrillicPluralization from './lib/cyrillic-pluralization';
import I18n from '../../public/javascripts/i18n';
import '@/widget/ui/styles/widget.scss';

declare global {
  interface Window {
    widgetParams: ChatWidgetProps;
    ChatWidget: {
      cable: actionCable.Cable;
      token: string;
      i18n: {
        t: (key: string, options?: object) => string;
      };
    };
  }
}

function initWidget(widgetParams: ChatWidgetProps) {
  I18n.translations.ru = ru;
  I18n.translations.en = en;
  I18n.pluralization.ru = cyrillicPluralization;
  I18n.defaultLocale = widgetParams.settings.lang;
  I18n.locale = widgetParams.settings.lang;

  window.ChatWidget = {
    i18n: I18n,
    token: widgetParams.settings.token,
    cable: actionCable.createConsumer(widgetParams.settings.wsUrl),
  };

  const props = buildInitialState(widgetParams);

  const widget = React.createElement(ChatWidget, props);
  ReactDOM.render(
    widget,
    document.getElementById('s2-root-chat'),
  );
}

initWidget(window.widgetParams);

window.addEventListener(
  'message',
  (event) => {
    if (event.data.action === 's2:widget:init') {
      initWidget(event.data.params);
    }

    if (event.data.action === 'crm:support-widget-removed') {
      ReactDOM.unmountComponentAtNode(document.getElementById('s2-root-chat'));
    }

    if (event.data.action === 'crm:support-widget-opened') {
      const widget = React.createElement(ChatWidget, buildInitialState(window.widgetParams));

      ReactDOM.render(
        widget,
        document.getElementById('s2-root-chat'),
      );
    }
  },
  false,
);
